import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
// mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
// component
import TopBackButton from '@/component/common/top-back-button';
import SFSwitch from '@/component/common/sf-switch';
import SFMenu from '@/component/my/sf-menu';
import SuccessDrawer from '@/component/common/success-drawer';
import { bio_auth, bio_reg_check, callback_fun_check } from '@/component/linkMobile/bio';
import AlertDialog from '@/component/mui/DialogAlert';
import SFAlertDialog from '@/component/common/sf-alert-dialog';
// lib & store
import { usePinInfo } from '@/store/zustand/store';
import {
  bioLocalStorage,
  deleteStorage,
  getStorage,
  localDeleteStorage,
  localGetStorage,
  localSetStorage,
  loginLocalStorage,
  setBioLocalStorage,
  setStorage,
} from '@/lib/storage';
import { encryptData } from '@/lib/Cryptos';
import { initStorage, sleep } from '@/lib/util';
// api
import ErrorRes from '@/api/server/ErrorRes';
import { withdrawalUserSns } from '@/api/server/user/delete';
// hook
import { BioUse } from './bio/BioUse';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function SecurityCenter() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openFingerPrintDrawer, setOpenFingerPrintDrawer] = React.useState(false);
  const [openScreenLockDrawer, setOpenScreenLockDrawer] = React.useState(false);
  const [screenLock, setScreenLock] = React.useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const pinInfo = usePinInfo();
  const [openDialog, setOpenDialog] = useState(false);
  const { isConnected } = useWeb3AuthConnect();

  // useEffect(() => {
  //   const bio = bioLocalStorage();
  //   // 바이오 등록 여부
  //   if (bio) {
  //     setFingerPrint(true);
  //     setIsReFingerPrint(true);
  //   }
  //   const reBio = getStorage('bio');
  //   let type = null;
  //   if (reBio) {
  //     const re = JSON.parse(reBio);
  //     type = re.type;
  //   }
  //   (async () => {
  //     // 핀 번호 체크 후 넘어오면 sns로그인 관련 기능을 아직 불러오지 못 한 상태?
  //     sleep(1000);
  //   })();

  //   if (pinInfo.active && pinInfo.path === '/securityCenter' && pinInfo.pinNum && bio && type) {
  //     console.log(`바이오 재등록 요청`);
  //     bioAuth(true);
  //     deleteStorage('bio');
  //     bioType.current = 'result';
  //   } else if (pinInfo.active && pinInfo.path === '/securityCenter' && pinInfo.pinNum && bio) {
  //     console.log(`바이오 사용 중`);
  //     // 바이오 사용 중
  //     bio_reg_check();
  //     bioType.current = 'check';
  //   } else if (pinInfo.active && pinInfo.path === '/securityCenter' && pinInfo.pinNum && !bio) {
  //     console.log(`바이오 신규 등록`);
  //     // 신규 등록
  //     bioAuth(false);
  //     bioType.current = 'result';
  //   }
  //   return () => {};
  // }, []);
  // useEffect(() => {
  //   if (pinInfo.active) {
  //     const paylaod = {
  //       pinNum: '',
  //       path: '',
  //       active: false,
  //     };
  //     dispatch(setPinInfo(paylaod));
  //   }

  //   return () => {};
  // }, [pinInfo]);

  useEffect(() => {
    if (isSubmit) {
      console.log(`??????????????????????`);
      const email = loginLocalStorage().email;
      (async () => {
        const re = await withdrawalUserSns(email);
        if (re.ret_code !== 200) {
          ErrorRes({ code: re.ret_code, msg: re.msg });
        }
        localDeleteStorage('auth');
        localDeleteStorage('login');
        setOpenDialog(true);
      })();
    }

    return () => {};
  }, [isSubmit]);

  // window.appInterFace = (val: any, data?: any) => {
  //   bioInterFace(val);
  // };
  // const bioInterFace = (val: any) => {
  //   if (bioType.current === 'check') {
  //     // 1: 인증정보 등록됨, 0: 미등록
  //     if (val === '1') {
  //       // 사용 중
  //       bioReg();
  //     } else if (val === '0') {
  //       // 신규 등록
  //       console.log(`신규`);
  //       bioAuth(false);
  //       bioType.current = 'result';
  //     }
  //   } else if (bioType.current === 'result') {
  //     console.log(`결과: ${val}`);
  //     // 1:인증성공,2:인증등록성공(안드로이드용),0:인증실패
  //     if (val === '1' || val === '2') {
  //       toast.success('성공'); //넘어온 인증값 확인
  //       if (!fingerPrint) {
  //         setFingerPrint(true);
  //         setIsReFingerPrint(true);
  //         setOpenFingerPrintDrawer(true);
  //       }
  //     } else {
  //       toast.error('인증에 실패 하였습니다.');
  //     }
  //     bioType.current = 'done';
  //   }
  // };
  // const bioReg = () => {
  //   console.log('사용중 완료');
  //   bioType.current = 'done';
  //   setFingerPrint(true);
  //   setIsReFingerPrint(true);
  // };
  // const bioAuth = (renewal: boolean = false) => {
  //   console.log(`isWeb3: ${isWeb3}`);
  //   console.log(web3UserInfo);
  //   const keyData = isWeb3 ? checkSns() : checkEmail();
  //   const re = setEncrypt(keyData);
  //   console.log(`encrypt: ${re}`);
  //   bio_auth(renewal, re);
  // };
  // const checkSns = (): string => {
  //   const idToken = localGetStorage('snsAddress').idToken;
  //   console.log(`check idToken: ${idToken}`);
  //   console.log(localGetStorage('snsAddress'));
  //   if (!idToken) {
  //     console.log(`bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb`);
  //     navigate('/signIn');
  //   }
  //   return idToken;
  // };
  // const checkEmail = (): string => {
  //   const email = loginLocalStorage().email;
  //   console.log(`aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa`);
  //   if (!email) {
  //     initStorage();
  //     console.log(`ccccccccccccccccccccccccccccccc`);
  //     navigate('/signIn');
  //   }
  //   return email;
  // };
  // const setEncrypt = (keyData: string): string => {
  //   const key = process.env.REACT_APP_CRYPTO_SOLT + keyData;
  //   const re = encryptData(pinInfo.pinNum, key);
  //   return re;
  // };
  // 당장 사용하지 않음
  const handleScreenLockSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setScreenLock(event.target.checked);
    if (event.target.checked) {
      setOpenScreenLockDrawer(true);
    }
  };

  // const handleFingerPrintSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setFingerPrint(event.target.checked);
  //   if (event.target.checked) {
  //     // navigate('/pinCheck/securityCenter');
  //     navigate('/pinComponent', {
  //       state: {
  //         pinType: 'check',
  //         title: 'PIN 번호 확인',
  //         returnUrl: '/securityCenter',
  //         options: {
  //           check: 'security',
  //         },
  //       },
  //     });
  //     // setOpenFingerPrintDrawer(true);
  //   } else {
  //     const temp = localGetStorage('login');
  //     const payload = {
  //       key: 'login',
  //       value: {
  //         ...temp,
  //         auth: '',
  //       },
  //     };
  //     localSetStorage(payload);
  //     setIsReFingerPrint(false);
  //   }
  // };
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title={t('validation.securityCenter')}
        backPath="/my"
        boxProps={{
          mb: 4,
        }}
      />
      <SFMenu.Menu>
        {isConnected ? (
          <>
            <BioUse isEmail={false} />
            <Divider sx={{ my: 2 }} />
            <SFMenu.ArrowRightItem
              text={t('validation.shuffleWithdrawal')}
              onClick={() => {
                setIsOpen(true);
              }}
            />
            <Divider sx={{ my: 2 }} />
          </>
        ) : (
          <>
            ※ {t('message.onlyShuffleUser')}
            <Divider sx={{ my: 2 }} />
            <SFMenu.ArrowButtonGroupItem
              title={t('validation.manageLogins')}
              items={[
                { href: '/changePw', name: t('validation.changePw') },
                { href: '/loginHistory', name: t('validation.loginHistory') },
              ]}
            />
            <Divider sx={{ my: 2 }} />
            <SFMenu.ArrowRightItem
              text={t('validation.shuffleWithdrawal')}
              onClick={() => {
                const auth = loginLocalStorage().auth;
                if (auth === 'oauth') {
                  setIsOpen(true);
                } else {
                  navigate('/delete');
                }
              }}
            />
            <Divider sx={{ my: 2 }} />
          </>
        )}
      </SFMenu.Menu>

      <SuccessDrawer
        open={openFingerPrintDrawer}
        onClose={() => {
          setOpenFingerPrintDrawer(false);
          setBioLocalStorage('bio_check', 0);
        }}
        title={t('validation.usingFingerprints')}
        content={
          <span>
            {t('message.usingFingerprints')}
            <br />
            {t('message.useSafely')}
          </span>
        }
      />
      <SuccessDrawer
        open={openScreenLockDrawer}
        onClose={() => {
          setOpenScreenLockDrawer(false);
        }}
        title={t('validation.useScreenLock')}
        content={
          <span>
            {t('message.screenLock')}
            <br />
            {t('message.useSafely')}
          </span>
        }
      />
      <AlertDialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setIsReturn={setIsSubmit}
        title={'회원탈퇴'}
        content={'sns로 로그인 하셨습니다. 탈퇴하시겠습니까?'}
      />
      <SFAlertDialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          navigate('/signInSns');
        }}
        fullWidth
      >
        {t('message.completedWithdrawal')}
      </SFAlertDialog>
    </Container>
  );
}
